import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import { MdDownload } from 'react-icons/md';
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import jsPDF from 'jspdf';
 

export const seo = {
    title: "Free Image to PDF Converter Online | Convert Images Easily",
    description: "Convert JPG, PNG, or any images to PDF online for free. Upload multiple images, arrange them, and download a single PDF instantly.",
    keywords: "image to pdf, jpg to pdf, png to pdf, convert image to pdf online, free image pdf converter, photo to pdf",
    url: "https://yourwebsite.com/image-to-pdf",
    image: "https://yourwebsite.com/assets/image-to-pdf-preview.png"
};

export default function ImageToPDF() {
    const [images, setImages] = useState([]);

    // Handle multiple file uploads
    const handleFiles = (files) => {
        const fileArray = Array.from(files).filter(file => file.type.startsWith("image"));
        const readers = fileArray.map(file => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.readAsDataURL(file);
            });
        });

        Promise.all(readers).then((results) => {
            setImages(results);
        });
    };

    const handleDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length > 0) {
            handleFiles(e.dataTransfer.files);
        }
    };

    // Convert images to PDF
    const handleDownloadPDF = () => {
        if (images.length === 0) return;

        const pdf = new jsPDF("p", "mm", "a4");
        let count = 0;

        images.forEach((imgData, index) => {
            const img = new Image();
            img.src = imgData;
            img.onload = function () {
                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
                let width = img.width;
                let height = img.height;

                // Scale to fit page
                if (width > pageWidth) {
                    const scale = pageWidth / width;
                    width *= scale;
                    height *= scale;
                }
                if (height > pageHeight) {
                    const scale = pageHeight / height;
                    width *= scale;
                    height *= scale;
                }

                pdf.addImage(img, "JPEG", (pageWidth - width) / 2, (pageHeight - height) / 2, width, height);

                if (index < images.length - 1) {
                    pdf.addPage();
                }

                count++;
                if (count === images.length) {
                    pdf.save("images.pdf");
                }
            };
        });
    };

    return (
        <div>
            <Header />
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
                <meta name="twitter:image" content={seo.image} />
            </Helmet>

            <div className='container_roots'>
                <div className='container_size p-3'>
                    <h2 className="text-xl font-bold mb-4">Free Image to PDF Converter</h2>

                    {/* Drag and Drop Zone */}
                    <div
                        className="Drag_Drop-body rounded"
                        onDrop={handleDrop}
                        onDragOver={(e) => e.preventDefault()}
                    >
                        {images.length > 0 ? (
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                                {images.map((src, i) => (
                                    <img
                                        key={i}
                                        src={src}
                                        alt={`preview-${i}`}
                                        className="preview rounded shadow"
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="Drag_Drop text-h2">
                                <label htmlFor="uploadImages" className="select-text text-h1 cursor">
                                    Drag & Drop Images or Click to Upload
                                </label>
                                <input
                                    id="uploadImages"
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    className="select_photo"
                                    onChange={(e) => handleFiles(e.target.files)}
                                />
                            </div>
                        )}
                    </div>

                    <br />
                    {images.length > 0 && (
                        <div
                            onClick={handleDownloadPDF}
                            className="button-ui fill p-33 cursor-pointer"
                        >
                            <MdDownload className='icon' />
                            Download PDF
                        </div>
                    )}

                    {images.length === 0 && (
                        <div className="description text-h2">
                            Convert images (JPG, PNG, etc.) to a single PDF file in just a few clicks. 
                            Upload or drag & drop your photos, and download them as a ready-to-use PDF.
                        </div>
                    )}
                </div>
            </div>

            <Footers />
            <Navbar />
        </div>
    );
}
